import React, { useEffect } from "react";
import useApi from "../utils/useApi";

const ViewUploadedSealSignPopup = ({ isOpen, onClose, title = "View Image", currentDetailsForImageUpload }) => {

  const {
    data: getDataUploadedImage,
    loading: getLoadingUploadedImage,
    error: getErrorUploadImage,
    get: getUploadedImage,
  } = useApi();

  useEffect(() => {
    if (!isOpen) return;

    let API_PATHS = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
    const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
    let loginame = currentDetailsForImageUpload.userObject.loginame;
    let doctype = currentDetailsForImageUpload.image_doc_type;

    getUploadedImage(
      `${BASE_URL}/api/CpaysCount/${COMPANY_CODE}/BASE64PICK/${loginame}/${doctype}`
    );
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  // Build image src from base64 response
  const base64Image = getDataUploadedImage?.[0]?.imgbase64
    ? `${getDataUploadedImage[0].imgbase64}`
    : null;

    console.log("base64Image", base64Image)

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
      onClick={handleOverlayClick}
    >
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg mx-4 p-6">

        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-800">
            {currentDetailsForImageUpload.image_doc_type}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl font-bold"
          >
            ✕
          </button>
        </div>

        <h3 className="text-sm font-medium text-gray-600 mb-4">
          Name — {currentDetailsForImageUpload.userObject.loginame}
        </h3>

        {/* Loading */}
        {getLoadingUploadedImage && (
          <div className="rounded-xl border border-gray-200 bg-gray-50 h-56 flex items-center justify-center">
            <p className="text-sm text-gray-400 animate-pulse">Loading image...</p>
          </div>
        )}

        {/* Error */}
        {getErrorUploadImage && !getLoadingUploadedImage && (
          <div className="rounded-xl border border-red-200 bg-red-50 h-56 flex flex-col items-center justify-center">
            <span className="text-3xl mb-2">⚠️</span>
            <p className="text-sm text-red-400">Failed to load image</p>
          </div>
        )}
{
    console.log("base64Image --", base64Image)
}
        {/* Image */}
        {!getLoadingUploadedImage && !getErrorUploadImage && (
          base64Image ? (
            <div className="rounded-xl overflow-hidden border border-gray-200 bg-gray-50">
              <img
                src={base64Image}
                alt={currentDetailsForImageUpload.image_doc_type}
                className="w-full object-contain max-h-96"
              />
            </div>
          ) : (
            <div className="rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 h-56 flex flex-col items-center justify-center">
              <span className="text-4xl mb-2">🖼️</span>
              <p className="text-sm text-gray-400">No image available</p>
            </div>
          )
        )}

        {/* Close Button */}
        <button
          onClick={onClose}
          className="mt-5 w-full py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
        >
          Close
        </button>

      </div>
    </div>
  );
};

export default ViewUploadedSealSignPopup;